import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";
import structuresStore from "./redux/furcinetStore";
import React, { lazy, Suspense } from "react";
import { ROUTES, BASENAME } from "./config/site.config";
import PageNotFound from "./pages/PageNotFound";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { theme } from "./theme";
import "./App.css";


const appTheme = createTheme(theme);

function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <Provider store={structuresStore}>
        <Router basename={BASENAME}>
          <Suspense fallback={<div></div>}>
            <Switch>
              <Route
                exact
                path={ROUTES.HOME_PATH}
                component={lazy(() => import("./pages/HomePage"))}
              />
              <Route
                path={ROUTES.JOIN_PATH}
                exact
                component={lazy(() => import("./pages/JoinPage"))}
              />
              <Route
                path={ROUTES.SUGGEST_PATH}
                exact
                component={lazy(() => import("./pages/SuggestPage"))}
              />
              <Route
                path={ROUTES.FURCINET_PATH}
                exact
                component={lazy(() => import("./pages/Furcinet"))}
              />
              <Route
                path={ROUTES.DETTAGLIO_PATH + "/:id"}
                exact
                component={lazy(() => import("./pages/StructureDetail"))}
              />
              <Route
                path={ROUTES.FURCIFOOD_PATH}
                exact
                component={lazy(() => import("./pages/FurciFood"))}
              />
              <Route
                path={ROUTES.FURCY_PATH}
                exact
                component={lazy(() => import("./pages/Furcy"))}
              />
              {/* <Route
                path={ROUTES.BLOG_PATH}
                exact
                component={lazy(() => import("./pages/BlogPage"))}
              />
              <Route
                path={ROUTES.BLOG_PATH + "/:id"}
                exact
                component={lazy(() => import("./pages/BlogPageDetail"))}
              /> */}
              <Route
                path={ROUTES.FURCINER_PATH}
                exact
                component={lazy(() => import("./pages/Furciner"))}
              />
              <Route
                path={ROUTES.CONTATTACI_PATH}
                exact
                component={lazy(() => import("./pages/Contacts"))}
              />
              <Route
                path={ROUTES.FAQ_PATH}
                exact
                component={lazy(() => import("./pages/Faq"))}
              />
              <Route
                path={ROUTES.TERMINI_PATH}
                exact
                component={lazy(() => import("./pages/TerminiECondizioni"))}
              />
              <Route path="*">
                <PageNotFound />
              </Route>
            </Switch>
          </Suspense>
        </Router>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
